import { gtagPageView } from './gtag';

export default function trackPageView() {
  gtagPageView();
}
